/** Tabs of the admin booking detail, selected through the `?tab=` search param. */
export type AdminDetailTab = "overview" | "payment" | "chat";

export const ADMIN_DETAIL_TAB_PARAM = "tab";

/** Search string that opens the admin booking detail on the given tab. */
export function adminDetailTabSearch(tab: Exclude<AdminDetailTab, "overview">): string {
  return `?${ADMIN_DETAIL_TAB_PARAM}=${tab}`;
}
